import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  createOrder = async (fields) => {
    try {
      const { body } = await Api.post(`/v2/ecommerce`, { payload: fields, endpoint: 'createOrder' }, true)

      console.log('res body', body)

      if (body?.status === 'success' && body?.orderNumber) {
        const visiblePhones = Array.isArray(fields?.user?.phones) ? fields.user.phones.filter(p => p.visible) : []
        const customerPhone = visiblePhones.length ? visiblePhones[0]?.phone : null

        const payload = {
          conversionId: body.orderNumber,
          conversionType: 'ecom_order',
          channel: 'web',
          customerPhone,
          valueEur: body?.product?.totalPrice
        }

        console.log('payload', payload);

        fetch('/api/attribution/order-confirmed', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(response => response.json())
          .then(result => {
          })
          .catch(err => { err => console.error('attribution order-confirmed failed', err) })
      }

      return body
    } catch (e) {
      console.error('createOrder error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  getDeliveryFormData = async ({ orderNumber, locale = 'ME' }) => {
    const defaultResponse = { product: null }

    try {
      const { body } = await Api.get(`/v2/ecommerce/${orderNumber}`, { endpoint: 'getDeliveryFormData', locale })

      if (body?.product) return body

      if (body.error) {
        defaultResponse.error = body.error
      }

      return defaultResponse
    } catch (e) {
      console.error('getDeliveryFormData error', e)
      defaultResponse.error = e
      return defaultResponse
    }
  }

  getInstallments = async ({ orderNumber, locale = 'ME' }) => {
    try {
      const { body } = await Api.get(`/v2/ecommerce/${orderNumber}`, { endpoint: 'getInstallmentOptions', locale })

      return body
    } catch (e) {
      console.error('getInstallments error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  getFinancingFormData = async ({ orderNumber, locale = 'ME' }) => {
    try {
      const { body } = await Api.get(`/v2/ecommerce/${orderNumber}`, { endpoint: 'getFinancingFormData', locale })

      return body
    } catch (e) {
      console.error('getFinancingFormData error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  submitFinancingApplication = async ({ fields }) => {
    try {
      const { body } = await Api.post(`/v2/ecommerce`, { payload: fields, endpoint: 'submitFinancingApplication' }, true)

      return body
    } catch (e) {
      console.error('submitFinancingApplication error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  submitOrder = async ({ orderNumber, fields }) => {
    try {
      const { body } = await Api.post(`/v2/ecommerce/${orderNumber}`, { payload: fields, endpoint: 'submitOrder' }, true)

      return body
    } catch (e) {
      console.error('submitOrder error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  getOrderConfirmation = async ({ orderNumber, locale = 'ME' }) => {
    try {
      const { body } = await Api.get(`/v2/ecommerce/${orderNumber}`, { endpoint: 'getOrderConfirmation', locale })

      return body
    } catch (e) {
      console.error('getOrderConfirmation error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  updateOrderQuantity = async ({ orderNumber, quantity }) => {
    try {
      const { body } = await Api.post(`/v2/ecommerce/${orderNumber}`, { payload: { quantity }, endpoint: 'updateOrderQuantity' }, true)

      return body
    } catch (e) {
      console.error('updateOrderQuantity error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  uploadImage = async fields => {
    try {
      const { body } = await Api.post(`/uploadImageOdoo`, fields, false)

      return body
    } catch (e) {
      console.error('uploadImage error', e)
      return { success: false, error: e.message || 'Unknown error' }
    }
  }

  createBankartTransaction = async (fields) => {
    const defaultResult = { status: Api.responseTypes.ERROR }

    try {
      const { body } = await Api.post('/v2/transaction/debit', fields)

      return body
    } catch (error) {
      console.log('createBankartTransaction error', error)
      return defaultResult
    }
  }
}